(function () {
  'use strict';

  var MAIN_VARIANT_ID = 42216227799100;
  var SPOON_VARIANT_ID = 42799374762044;
  var BOTTLE_VARIANT_ID = 46112997605436;
  var JAR_PRICE = 109.00;
  var SPOON_PRICE = 12.99;
  var BOTTLE_PRICE = 32.99;
  var DISCOUNT_CODES = { 2: 'CELSIUS-2JARS', 3: 'CELSIUS-3JARS' };

  var SELLING_PLANS = {
    monthly: '1463287868',
    every2months: '1491337276',
    every3months: '2480472124',
    every4months: '2480504892',
    every6months: '2480537660'
  };

  var FREQ_LABELS = {
    '1463287868': 'every month',
    '1491337276': 'every 2 months',
    '2480472124': 'every 3 months',
    '2480504892': 'every 4 months',
    '2480537660': 'every 6 months'
  };

  var JAR_IMG = 'https://cdn.shopify.com/s/files/1/0575/3624/9916/files/shilajit-resin-hero-celsius-medicinals-best-shilajit-restoring-what-modern-life-depletes.webp?v=1788312338';
  var SPOON_IMG = 'https://cdn.shopify.com/s/files/1/0575/3624/9916/files/shilajit-dosage-spoon-celsius-resin-how-much.webp?v=1790565655';
  var BOTTLE_IMG = 'https://cdn.shopify.com/s/files/1/0575/3624/9916/files/Ritual-bottle-celsius-medicians-shilajit.webp?v=1788223722';

  var state = {
    qty: 2,
    purchaseType: 'subscribe',
    sellingPlanId: SELLING_PLANS.monthly
  };

  function fmt(n) {
    var fixed = parseFloat(n.toFixed(2));
    var str = fixed.toString();
    var parts = str.split('.');
    if (parts.length === 1) return '$' + parts[0];
    var dec = parts[1];
    if (dec === '0' || dec === '00') return '$' + parts[0];
    if (dec.length === 1) dec = dec + '0';
    return '$' + parts[0] + '.' + dec;
  }

  function calcPrices(qty, isSubscription) {
    var volumeDiscount = qty === 2 ? 0.10 : qty === 3 ? 0.15 : 0;
    var subDiscount = isSubscription ? 0.20 : 0;
    var totalDiscount = 1 - ((1 - volumeDiscount) * (1 - subDiscount));
    var baseTotal = JAR_PRICE * qty;
    var price = parseFloat((baseTotal * (1 - totalDiscount)).toFixed(2));
    var perServe = parseFloat((price / (qty * 60)).toFixed(2));
    var rrp = JAR_PRICE * qty;
    if (qty >= 2) rrp += SPOON_PRICE;
    if (isSubscription) rrp += BOTTLE_PRICE;
    rrp = parseFloat(rrp.toFixed(2));
    return { price: price, rrp: rrp, perServe: perServe };
  }

  function updateUI() {
    var isSubscribe = state.purchaseType === 'subscribe';
    var prices = calcPrices(state.qty, isSubscribe);
    var spoonUnlocked = state.qty >= 2;
    var bottleUnlocked = isSubscribe;

    // Qty tabs
    [1, 2, 3].forEach(function (q) {
      var tab = document.querySelector('.ir-b-qty-tab[data-qty="' + q + '"]');
      if (tab) tab.classList.toggle('active', q === state.qty);
    });

    // Purchase type toggle
    document.querySelectorAll('.ir-b-type-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-type') === state.purchaseType);
    });

    // Frequency wrap
    var freqWrap = document.querySelector('.ir-b-freq-wrap');
    if (freqWrap) freqWrap.classList.toggle('visible', isSubscribe);

    // Price
    var priceEl = document.querySelector('.ir-b-price');
    var rrpEl = document.querySelector('.ir-b-price-rrp');
    var perServeEl = document.querySelector('.ir-b-per-serve');
    if (priceEl) priceEl.textContent = fmt(prices.price);
    if (rrpEl) {
      rrpEl.textContent = fmt(prices.rrp);
      rrpEl.style.display = prices.price < prices.rrp ? '' : 'none';
    }
    if (perServeEl) perServeEl.textContent = fmt(prices.perServe);

    // Supply line — cost per jar + total savings
    var supplyEl = document.querySelector('.ir-b-price-supply');
    if (supplyEl) {
      var perJar = parseFloat((prices.price / state.qty).toFixed(2));
      var savings = parseFloat((prices.rrp - prices.price).toFixed(2));
      supplyEl.textContent = savings > 0
        ? fmt(perJar) + '/jar · Save ' + fmt(savings)
        : fmt(perJar) + '/jar';
    }

    // ATC price
    var atcPrice = document.querySelector('.ir-b-atc-price');
    if (atcPrice) atcPrice.textContent = fmt(prices.price);

    // Inclusions: subscribe row
    var inclSubscribe = document.getElementById('ir-b-incl-subscribe');
    if (inclSubscribe) inclSubscribe.style.display = isSubscribe ? 'flex' : 'none';

    // Inclusions: spoon
    var inclSpoon = document.getElementById('ir-b-incl-spoon');
    if (inclSpoon) {
      var spoonStatus = inclSpoon.querySelector('.ir-b-incl-status');
      var spoonSub = inclSpoon.querySelector('.ir-b-incl-sub');
      if (spoonUnlocked) {
        spoonStatus.innerHTML = '<s>$' + SPOON_PRICE.toFixed(2) + '</s> FREE';
        spoonStatus.className = 'ir-b-incl-status ir-b-incl-free';
        if (spoonSub) spoonSub.textContent = '';
      } else {
        spoonStatus.textContent = 'LOCKED';
        spoonStatus.className = 'ir-b-incl-status ir-b-incl-locked';
        if (spoonSub) spoonSub.textContent = 'Add 1 more jar to unlock';
      }
      inclSpoon.classList.toggle('ir-b-incl-row--locked', !spoonUnlocked);
    }

    // Inclusions: ritual bottle
    var inclBottle = document.getElementById('ir-b-incl-bottle');
    if (inclBottle) {
      var bottleStatus = inclBottle.querySelector('.ir-b-incl-status');
      var bottleSub = inclBottle.querySelector('.ir-b-incl-sub');
      if (bottleUnlocked) {
        bottleStatus.innerHTML = '<s>$' + BOTTLE_PRICE.toFixed(2) + '</s> FREE';
        bottleStatus.className = 'ir-b-incl-status ir-b-incl-free';
        if (bottleSub) bottleSub.textContent = '';
      } else {
        bottleStatus.textContent = 'LOCKED';
        bottleStatus.className = 'ir-b-incl-status ir-b-incl-locked';
        if (bottleSub) bottleSub.textContent = 'Free with auto-deliver';
      }
      inclBottle.classList.toggle('ir-b-incl-row--locked', !bottleUnlocked);
    }

    // Discount note (one-time only)
    var discountNote = document.getElementById('ir-b-discount-note');
    if (discountNote) discountNote.classList.toggle('visible', !isSubscribe);

    // Broadcast state
    window.__irBundleState = {
      qty: state.qty,
      purchaseType: state.purchaseType,
      price: prices.price,
      rrp: prices.rrp
    };
    document.dispatchEvent(new CustomEvent('ir-bundle:update', { detail: window.__irBundleState }));
  }

  function handleATC() {
    var btn = document.querySelector('.ir-b-atc-btn');
    var atcLabel = document.querySelector('.ir-b-atc-label');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    if (atcLabel) atcLabel.textContent = 'Adding...';

    var isSubscribe = state.purchaseType === 'subscribe';
    var spoonUnlocked = state.qty >= 2;
    var bottleUnlocked = isSubscribe;
    var items = [];

    var mainItem = { id: MAIN_VARIANT_ID, quantity: state.qty };
    if (isSubscribe) mainItem.selling_plan = parseInt(state.sellingPlanId, 10);
    items.push(mainItem);

    if (spoonUnlocked) items.push({ id: SPOON_VARIANT_ID, quantity: 1 });
    if (bottleUnlocked) items.push({ id: BOTTLE_VARIANT_ID, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return res.json();
      })
      .then(function () {
        var discountCode = DISCOUNT_CODES[state.qty];
        var discountFetch = discountCode
          ? fetch('/discount/' + discountCode, { credentials: 'same-origin', redirect: 'follow' })
          : Promise.resolve();

        return discountFetch.then(function () {
          var drawer = document.querySelector('cart-drawer');
          fetch('/cart?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data['cart-drawer'] && drawer) {
                var tmp = document.createElement('div');
                tmp.innerHTML = data['cart-drawer'];
                var freshInner = tmp.querySelector('.drawer__inner');
                var liveInner = drawer.querySelector('.drawer__inner');
                if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
                var freshDrawerEl = tmp.querySelector('cart-drawer');
                if (freshDrawerEl) drawer.classList.toggle('is-empty', freshDrawerEl.classList.contains('is-empty'));
              }
              if (data['cart-icon-bubble']) {
                var bubbleTarget = document.querySelector('#cart-icon-bubble');
                if (bubbleTarget) {
                  var tmp2 = document.createElement('div');
                  tmp2.innerHTML = data['cart-icon-bubble'];
                  var freshBubble = tmp2.firstElementChild;
                  if (freshBubble) bubbleTarget.innerHTML = freshBubble.innerHTML;
                }
              }
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                var cartBtn = document.querySelector('[data-cart-icon-bubble], .cart-icon-bubble');
                if (cartBtn) cartBtn.click();
              }
            })
            .catch(function () {
              if (drawer && typeof drawer.open === 'function') drawer.open();
              else window.location.href = '/cart';
            });
        });
      })
      .catch(function (err) {
        alert(err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        btn.disabled = false;
        if (atcLabel) atcLabel.textContent = 'ADD TO CART';
      });
  }

  function buildHTML() {
    var wrapper = document.querySelector('.ir-b-widget');
    if (!wrapper) return;

    wrapper.innerHTML = [
      // ── Qty tabs ──
      '<div class="ir-b-qty-tabs">',
        '<button class="ir-b-qty-tab" data-qty="1" type="button">',
          '<span class="ir-b-tab-label">1 Jar</span>',
          '<span class="ir-b-tab-supply">60-Day Supply</span>',
        '</button>',
        '<button class="ir-b-qty-tab" data-qty="2" type="button">',
          '<span class="ir-b-tab-badge">MOST POPULAR</span>',
          '<span class="ir-b-tab-label">2 Jars</span>',
          '<span class="ir-b-tab-supply">120-Day Supply</span>',
        '</button>',
        '<button class="ir-b-qty-tab" data-qty="3" type="button">',
          '<span class="ir-b-tab-badge">BEST VALUE</span>',
          '<span class="ir-b-tab-label">3 Jars</span>',
          '<span class="ir-b-tab-supply">180-Day Supply</span>',
        '</button>',
      '</div>',

      // ── Pill-style purchase type toggle ──
      '<div class="ir-b-type-toggle">',
        '<button class="ir-b-type-btn" data-type="onetime" type="button">One-time</button>',
        '<button class="ir-b-type-btn" data-type="subscribe" type="button">',
          'Auto-Deliver ',
          '<span class="ir-b-save-pill">SAVE 20%</span>',
        '</button>',
      '</div>',

      // ── Frequency select (subscribe only) ──
      '<div class="ir-b-freq-wrap">',
        '<div class="ir-b-freq-label">Delivery frequency</div>',
        '<select class="ir-b-freq-select">',
          '<option value="' + SELLING_PLANS.monthly + '">Every Month</option>',
          '<option value="' + SELLING_PLANS.every2months + '">Every 2 Months</option>',
          '<option value="' + SELLING_PLANS.every3months + '">Every 3 Months</option>',
          '<option value="' + SELLING_PLANS.every4months + '">Every 4 Months</option>',
          '<option value="' + SELLING_PLANS.every6months + '">Every 6 Months</option>',
        '</select>',
        '<p class="ir-b-no-lock-in">No lock-ins. Cancel or pause anytime.</p>',
      '</div>',

      // ── Price block ──
      '<div class="ir-b-price-block">',
        '<div class="ir-b-price-left">',
          '<div class="ir-b-price-row">',
            '<span class="ir-b-price"></span>',
            '<span class="ir-b-price-rrp"></span>',
          '</div>',
          '<div class="ir-b-price-supply"></div>',
        '</div>',
        '<div class="ir-b-price-right">',
          '<span class="ir-b-per-serve"></span>',
          '<span class="ir-b-per-serve-label">per serve</span>',
        '</div>',
      '</div>',

      // ── Inclusions panel ──
      '<div class="ir-b-inclusions">',
        '<div class="ir-b-inclusions-header">Included with your order</div>',

        // Subscribe discount (auto-deliver only)
        '<div class="ir-b-incl-row" id="ir-b-incl-subscribe" style="display:none">',
          '<div class="ir-b-incl-icon-wrap">',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
          '</div>',
          '<div class="ir-b-incl-info">',
            '<span class="ir-b-incl-title">20% additional auto-deliver savings</span>',
          '</div>',
          '<span class="ir-b-incl-status ir-b-incl-applied">APPLIED</span>',
        '</div>',

        // Free Dosage Spoon (2+ jars)
        '<div class="ir-b-incl-row ir-b-incl-row--locked" id="ir-b-incl-spoon">',
          '<div class="ir-b-incl-img-wrap">',
            '<img src="' + SPOON_IMG + '" alt="Dosage Spoon" class="ir-b-incl-img" loading="lazy">',
          '</div>',
          '<div class="ir-b-incl-info">',
            '<span class="ir-b-incl-title">Free Dosage Spoon</span>',
            '<span class="ir-b-incl-sub">Add 1 more jar to unlock</span>',
          '</div>',
          '<span class="ir-b-incl-status ir-b-incl-locked">LOCKED</span>',
        '</div>',

        // The Ritual Bottle (3 jars + auto-deliver)
        '<div class="ir-b-incl-row ir-b-incl-row--locked" id="ir-b-incl-bottle">',
          '<div class="ir-b-incl-img-wrap">',
            '<img src="' + BOTTLE_IMG + '" alt="The Ritual Bottle" class="ir-b-incl-img" loading="lazy">',
          '</div>',
          '<div class="ir-b-incl-info">',
            '<span class="ir-b-incl-title">Free Ritual Bottle</span>',
            '<span class="ir-b-incl-sub">Free with auto-deliver</span>',
          '</div>',
          '<span class="ir-b-incl-status ir-b-incl-locked">LOCKED</span>',
        '</div>',

        // Free shipping (always included — orders start at $117)
        '<div class="ir-b-incl-row">',
          '<div class="ir-b-incl-icon-wrap">',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
          '</div>',
          '<div class="ir-b-incl-info">',
            '<span class="ir-b-incl-title">Free Shipping</span>',
          '</div>',
          '<span class="ir-b-incl-status ir-b-incl-applied">INCLUDED</span>',
        '</div>',
      '</div>',

      // ── ATC button ──
      '<button class="ir-b-atc-btn" type="button">',
        '<span class="ir-b-atc-label">ADD TO CART</span>',
        '<span class="ir-b-atc-dot">&middot;</span>',
        '<span class="ir-b-atc-price"></span>',
      '</button>',

      // ── One-time discount note ──
      '<p class="ir-b-discount-note" id="ir-b-discount-note">Have a discount code? Apply it at checkout</p>',
    ].join('');
  }

  function bindEvents() {
    document.querySelectorAll('.ir-b-qty-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var qty = parseInt(tab.getAttribute('data-qty'), 10);
        if (qty === state.qty) return;
        state.qty = qty;
        updateUI();
      });
    });

    document.querySelectorAll('.ir-b-type-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-type');
        if (type === state.purchaseType) return;
        state.purchaseType = type;
        updateUI();
      });
    });

    var freqSelect = document.querySelector('.ir-b-freq-select');
    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        state.sellingPlanId = freqSelect.value;
        updateUI();
      });
    }

    var atcBtn = document.querySelector('.ir-b-atc-btn');
    if (atcBtn) atcBtn.addEventListener('click', handleATC);
  }

  function init() {
    var wrapper = document.querySelector('.ir-b-widget');
    if (!wrapper) return;
    buildHTML();
    bindEvents();
    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
